import { fetchDistricts } from '@/core/api/districts'
import { CLEAR_STATE, END_REQUEST, SET_STATE, START_REQUEST } from '@/store/mutation-types'

export default {
  namespaced: true,
  state: {
    loading: false,
    items: [],
  },
  actions: {
    async FETCH({ commit }) {
      commit(START_REQUEST)

      commit(SET_STATE, await fetchDistricts())

      commit(END_REQUEST)
    },
  },
  mutations: {
    [START_REQUEST]: state => {
      state.loading = true
    },
    [END_REQUEST]: state => {
      state.loading = false
    },
    [SET_STATE]: (state, items) => {
      state.items = items
    },
    [CLEAR_STATE]: state => {
      state.items = []
    },
  },
}
